import controller from './specific-act-list.controller';
import template from './specific-act-list.view.html';

let SpecificActListComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default SpecificActListComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/specific-act-list/specific-act-list.component.js
 **/